import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LogoIcon, MenuIcon, XIcon } from '../icons/Icons';
import { useSettings } from '../../context/SettingsContext';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  const { settings } = useSettings();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About Us' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/impact', label: 'Impact' },
    { path: '/blog', label: 'Blog' },
    { path: '/contact', label: 'Contact' }
  ];

  return (
    <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
      <div className="container header-container">
        <Link to="/" className="header-logo">
          {(settings.logo_url || settings.logo_light_url) ? (
            <>
              {settings.logo_light_url && (
                <img 
                  src={settings.logo_light_url} 
                  alt={settings.site_name || 'Fuwali'} 
                  className="header-logo-img header-logo-light" 
                />
              )}
              {settings.logo_url && (
                <img 
                  src={settings.logo_url} 
                  alt={settings.site_name || 'Fuwali'} 
                  className="header-logo-img header-logo-dark" 
                />
              )}
            </>
          ) : (
            <>
              <LogoIcon size={45} />
              <div className="header-logo-text">
                <span className="header-logo-name">{settings.site_name?.split(' ')[0] || 'Fuwali'}</span>
                <span className="header-logo-tagline">Investments</span>
              </div>
            </>
          )}
        </Link>

        <nav className={`header-nav ${isMobileMenuOpen ? 'header-nav-open' : ''}`}>
          {navLinks.map(link => (
            <Link
              key={link.path}
              to={link.path}
              className={`header-nav-link ${location.pathname === link.path ? 'active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        <button
          className="header-mobile-toggle"
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle menu"
        >
          {isMobileMenuOpen ? <XIcon size={24} /> : <MenuIcon size={24} />}
        </button>
      </div>
    </header>
  );
};

export default Header;
